import { Auth } from "shared/@auth/Auth";
import { useQuery } from "react-query";

export const useSessionAttendance = (filters) => {
  const { makeAuthedRequest } = Auth.useContainer();

  return useQuery(
    ["SessionAttendance", filters],
    () => {
      const encodedEvents = filters.events.map(encodeURIComponent).join(";");
      const encodedSessions = filters.sessions
        .map(encodeURIComponent)
        .join(";");
      return makeAuthedRequest(
        `v1/reporting/session-attendance/eventId/${encodedEvents}/sessionId/${encodedSessions}`,
        {
          method: "GET",
        }
      ).then((res) => res.json());
    },
    {
      enabled: !!filters,
      staleTime: 0,
      refetchOnWindowFocus: false,
    }
  );
};
